import { render, staticRenderFns } from "./CategoryMain.vue?vue&type=template&id=483266cc&scoped=true"
import script from "./CategoryMain.vue?vue&type=script&lang=js"
export * from "./CategoryMain.vue?vue&type=script&lang=js"
import style0 from "./CategoryMain.vue?vue&type=style&index=0&id=483266cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483266cc",
  null
  
)

export default component.exports